class RelatedCollectionsCarousel {
  constructor(wrapper) {
    this.wrapper = wrapper;
    // Buscamos el track por atributo o por clase nativa para asegurar que lo encuentra
    this.track = wrapper.querySelector('[data-carousel-track]') || wrapper.querySelector('.related-collections-carousel__track');
    
    if (!this.track || this.track.children.length === 0) return;

    this.position = 0;
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeftStart = 0;
    this.rafId = null;
    
    this.singleSetWidth = 0;
    this.needsRealMeasurement = true;

    this.init();
  }

  init() {
    // 1. Clonar los elementos de forma masiva para asegurar el colchón infinito
    this.cloneCards();

    // 2. Captura de eventos para arrastrar (Ratón y Pantallas táctiles)
    this.wrapper.addEventListener('mousedown', this.onDragStart.bind(this));
    this.wrapper.addEventListener('touchstart', this.onDragStart.bind(this), { passive: true });
    this.wrapper.addEventListener('mousemove', this.onDragMove.bind(this));
    this.wrapper.addEventListener('touchmove', this.onDragMove.bind(this), { passive: true });
    
    window.addEventListener('mouseup', this.onDragEnd.bind(this));
    window.addEventListener('touchend', this.onDragEnd.bind(this));
    this.wrapper.addEventListener('mouseleave', this.onDragEnd.bind(this));
    this.wrapper.addEventListener('wheel', this.onWheel.bind(this), { passive: true });

    // Recalcular dimensiones si cambia la pantalla
    window.addEventListener('resize', () => {
      this.needsRealMeasurement = true;
      this.updateWidths();
    });

    // 3. Arrancar la animación continua
    this.startAutoplay();
  }

  cloneCards() {
    // Capturamos los elementos originales reales instalados en el HTML
    const originalCards = Array.from(this.track.children);
    this.originalCount = originalCards.length;
    
    // Clonamos el set de tarjetas 3 veces (4 sets en total) para garantizar que llenen la pantalla
    for (let i = 0; i < 3; i++) {
      originalCards.forEach((card) => {
        const clone = card.cloneNode(true);
        this.track.appendChild(clone);
      });
    }
    
    this.cards = Array.from(this.track.children);
    this.updateWidths();
  }

  updateWidths() {
    const originalCards = this.cards.slice(0, this.originalCount);
    let width = 0;
    const style = getComputedStyle(this.track);
    const gap = parseFloat(style.gap) || 0;
    
    let hasZeroWidth = false;
    originalCards.forEach((card) => {
      const cardWidth = card.offsetWidth;
      if (cardWidth <= 0) hasZeroWidth = true;
      width += cardWidth + gap;
    });
    
    // Si el CSS no ha cargado aún y da 0, aplicamos un ancho estimado provisional para que ruede
    if (hasZeroWidth || width <= 50) {
      const estimatedCardWidth = window.innerWidth > 749 ? 280 : 190;
      this.singleSetWidth = this.originalCount * (estimatedCardWidth + gap);
      this.needsRealMeasurement = true;
    } else {
      this.singleSetWidth = width;
      this.needsRealMeasurement = false; // Ya tenemos la medida real de la pantalla
    }
  }

  startAutoplay() {
    const animate = () => {
      // Si todavía necesita medir el tamaño real porque antes el CSS no estaba listo, mide de nuevo
      if (this.needsRealMeasurement) {
        this.updateWidths();
      }

      // Si el usuario no está arrastrando manualmente, el carrusel avanza de forma continua
      if (!this.isDragging) {
        this.position -= 1; // Velocidad constante (1px por frame)

        // Reseteo limpio al llegar al final del primer bloque original
        if (Math.abs(this.position) >= this.singleSetWidth) {
          this.position = 0;
        }
        
        this.applyTransform();
      }
      this.rafId = requestAnimationFrame(animate);
    };
    
    this.rafId = requestAnimationFrame(animate);
  }

  applyTransform() {
    this.track.style.transform = `translateX(${this.position}px)`;
  }

  onDragStart(event) {
    this.isDragging = true;
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    this.startX = clientX;
    this.scrollLeftStart = this.position;
    this.track.style.transition = 'none';
  }

  onDragMove(event) {
    if (!this.isDragging) return;
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    const delta = clientX - this.startX;
    this.position = this.scrollLeftStart + delta;

    // Normalizar posición durante el arrastre manual
    if (this.position > 0) {
      this.position -= this.singleSetWidth;
    }
    if (Math.abs(this.position) >= this.singleSetWidth) {
      this.position = this.position % this.singleSetWidth;
    }

    this.applyTransform();
  }

  onDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.style.transition = '';
  }

  onWheel(event) {
    this.position -= event.deltaY * 0.5;

    if (this.position > 0) {
      this.position -= this.singleSetWidth;
    }
    if (Math.abs(this.position) >= this.singleSetWidth) {
      this.position = this.position % this.singleSetWidth;
    }

    this.applyTransform();
  }
}

function initRelatedCollectionsCarousels() {
  document.querySelectorAll('[data-carousel]').forEach((wrapper) => {
    if (wrapper.dataset.initialized) return;
    wrapper.dataset.initialized = 'true';
    new RelatedCollectionsCarousel(wrapper);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelatedCollectionsCarousels);
} else {
  initRelatedCollectionsCarousels();
}
document.addEventListener('shopify:section:load', initRelatedCollectionsCarousels);